export default "__VITE_ASSET__11267b4b__"